module.exports = __webpack_public_path__ + "static/card-clock-f64ef899c87f6e0510d13099d3b18c9f.svg";